module.exports = __webpack_public_path__ + "static/media/brochure.d837a508.png";